import { render } from "./FeedbackAdminPanel.vue?vue&type=template&id=65e35fdb&scoped=true"
import script from "./FeedbackAdminPanel.vue?vue&type=script&lang=js"
export * from "./FeedbackAdminPanel.vue?vue&type=script&lang=js"

import "./FeedbackAdminPanel.vue?vue&type=style&index=0&id=65e35fdb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e35fdb"]])

export default __exports__